export const DEALER_VENDOR_LIST_CONSTANT_CONSTANTS = {
    TO_REGISTER : "To register a new Dealer or Vendor please submit the Vendor's and send the Vendor Setup Form to "
}